import { render, staticRenderFns } from "./StowageItemDialog.vue?vue&type=template&id=b03ffff4&"
import script from "./StowageItemDialog.vue?vue&type=script&lang=js&"
export * from "./StowageItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports